import Vue from 'vue'
import App from './App'
import router from './router'
import '@/assets/css/reset.scss'
import '@/assets/css/common.css'
import store from './store/index'
import axios from 'axios';
import ElementUI from 'element-ui';
import { Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import http from './utils/http.js'
import global from './utils/common';
import help from './utils/help'
import code from './service/code'
import api from './service/api'
import printPlugin from './utils/printPlugin';
import { quillEditor } from 'vue-quill-editor'; 
import '@fortawesome/fontawesome-free/css/all.min.css'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// import Quill from "quill";
// import ImageResize from "quill-image-resize-module"; // 引用
// import { ImageDrop } from "quill-image-drop-module";
// Quill.register("modules/imageDrop", ImageDrop);
// Quill.register("modules/imageResize", ImageResize); // 注册



Vue.use(printPlugin);
Vue.use(ElementUI)
Vue.use(quillEditor)

Vue.config.productionTip = false
Vue.prototype.$global = global
Vue.prototype.$help = help;
Vue.prototype.$code = code;
Vue.prototype.$api = api;
Vue.prototype.$axios = axios;
Vue.prototype.$http = http;

// 全局路由前置守卫
router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) {
        let user = localStorage.getItem("token");
        if (user) {
            next()
        } else {
            Message.error('请先登录！');

            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
        }
    }
    next()
})

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
})


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js